import React, { ReactElement } from 'react';
import {
  Box, Button, Flex, Text, useColorModeValue,
} from '@chakra-ui/react';
import { FiInbox } from 'react-icons/fi';

// item 322d — the ONE empty-state treatment. An empty grid used to render nothing
// (indistinguishable from "still loading"); this says plainly that there's no data
// and, when given an action, what to do about it.
const EmptyState: React.FC<{
  icon?: ReactElement;
  heading?: string;
  subtext?: string;
  actionLabel?: string;
  onAction?: () => void;
}> = ({
  icon, heading = 'Nothing here yet', subtext, actionLabel, onAction,
}) => {
  const ringBg = useColorModeValue('blackAlpha.50', 'whiteAlpha.100');
  const subColor = useColorModeValue('gray.600', 'whiteAlpha.700');
  return (
    <Flex direction="column" align="center" justify="center" py={12} px={6} gap={3} role="status">
      <Flex
        w="56px"
        h="56px"
        align="center"
        justify="center"
        borderRadius="full"
        bg={ringBg}
        fontSize="24px"
        color={subColor}
      >
        {icon ?? <FiInbox />}
      </Flex>
      <Text fontWeight="semibold">{heading}</Text>
      {subtext && (
        <Text fontSize="sm" color={subColor} textAlign="center" maxW="420px">
          {subtext}
        </Text>
      )}
      {actionLabel && onAction && (
        <Box mt={1}>
          <Button size="sm" variant="outline" onClick={onAction}>{actionLabel}</Button>
        </Box>
      )}
    </Flex>
  );
};

EmptyState.defaultProps = {
  icon: undefined,
  heading: 'Nothing here yet',
  subtext: undefined,
  actionLabel: undefined,
  onAction: undefined,
};

export default EmptyState;
